import React, { useMemo, useState } from "react";
import Table from "../../../components/Table";
import TitleButtons from "../../../components/TitleButtons";
import { useNavigate } from "react-router-dom";
import { generatePdfReport } from "../../../utils/pdf/generatePdfReport";
import { useProdutosDisponiveis } from "../Produtos/produtosData";

const RecursosHumanosProdutos: React.FC = () => {
  const navigate = useNavigate();
  const { produtos, loading } = useProdutosDisponiveis();

  const headers = useMemo(
    () => [
      "Código",
      "NCM",
      "Nome do Produto",
      "Custo Unitário",
      "Classificação",
      "Posição",
    ],
    []
  );

  const columnWidths = useMemo(
    () => ["100px", "60px", "270px", "100px", "20px", "10px"],
    []
  );

  const rows = useMemo(
    () =>
      produtos.map((p) => [
        p.codigo,
        p.ncm,
        p.nome,
        p.custo_unitario ?? "N/A",
        p.classificacao,
        p.posicao,
      ]),
    [produtos]
  );

  const [selectedColumns, setSelectedColumns] = useState<boolean[]>(
    headers.map(() => true)
  );

  const [selectedProduct, setSelectedProduct] = useState<any | null>(null);

  const enabledColumnIndexes = useMemo(
    () =>
      selectedColumns
        .map((checked, i) => (checked ? i : -1))
        .filter((i) => i !== -1),
    [selectedColumns]
  );

  // Helpers p/ PDF seguro (quando gera com todas as linhas passadas ao Table)
  const firstCode = rows.length ? rows[0][0] : "—";
  const lastCode = rows.length ? rows[rows.length - 1][0] : "—";
  const nextCode = `PRD001${(produtos.length + 1).toString().padStart(2, "0")}`;

  return (
    <div>
      <TitleButtons
        title="Documentos da Empresa - Produtos"
        buttons={[
          {
            label: "Gerar Relatório",
            onClick: () =>
              generatePdfReport({
                reportTitle: "Relatório de Produtos - Recursos Humanos",
                fileNamePrefix: "Recursos Humanos-Produtos",
                subtitle: "Informações dos produtos registrados",
                headers,
                rows, // OBS: estas são TODAS as linhas; se quiser gerar apenas as VISÍVEIS após filtro do Table, veja a observação abaixo
                custoColIndex: 3,
                enabledColumns: enabledColumnIndexes,
                footerLines: [
                  rows.length
                    ? `Códigos Utilizados: ${firstCode} - ${lastCode}`
                    : "Sem produtos",
                  `Próximo Código Disponível: ${nextCode}`,
                ],
              }),
            variant: "secondary",
            dropdownOptions: headers.map((h, i) => ({
              label: h,
              checked: selectedColumns[i],
            })),
            onOptionChange: (index, checked) => {
              const updated = [...selectedColumns];
              updated[index] = checked;
              setSelectedColumns(updated);
            },
          },
          {
            label: "Registrar Produto",
            onClick: () =>
              navigate("/recursos-humanos/produtos/registrar-produto"),
            variant: "primary",
          },
        ]}
      />

      <Table
        headers={headers}
        rows={rows}
        columnWidths={columnWidths}
        // Agora: abre a rota de detalhes em vez de setar state local
        onDoubleClick={(_viewIndex, rowData /*, originalIndex */) => {
          const codigoIdx = headers.indexOf("Código");
          const codigo = String(rowData[codigoIdx] ?? "");
          if (codigo) {
            navigate(`/suprimentos/produtos/${encodeURIComponent(codigo)}`);
          }
        }}
        responsiveWidths={{
          1300: {
            1: "100px",
            2: "0px",
            3: "270px",
            4: "140px",
            5: "0px",
            6: "60px",
          },
          1200: {
            1: "100px",
            2: "0px",
            3: "270px",
            4: "140px",
            5: "0px",
            6: "60px",
          },
        }}
      />

      {loading && (
        <div style={{ padding: 16, opacity: 0.7, fontSize: 14 }}>
          Carregando produtos…
        </div>
      )}
    </div>
  );
};

export default RecursosHumanosProdutos;
